import type { SEOIntent, SEOReportPlanId } from "@/lib/seo-intents";

export interface ReportInputBirthContext {
  name?: string;
  birthDate?: string;
  birthTime?: string;
  birthPlace?: string;
}

function clean(value: string | undefined): string {
  return typeof value === "string" ? value.trim() : "";
}

function appendBirthContext(params: URLSearchParams, birthContext: ReportInputBirthContext): void {
  const values = {
    name: clean(birthContext.name),
    dob: birthContext.birthDate ?? "",
    time: birthContext.birthTime ?? "",
    place: clean(birthContext.birthPlace),
  };
  for (const [key, value] of Object.entries(values)) {
    if (value) params.set(key, value);
  }
}

/**
 * The hash flag a collect-inputs bridge puts on its form link. On the kundali
 * result it makes the bridged plan's checkout the next thing the seeker sees
 * (KundaliResult.helpers `primaryReportArrival`), which is what the bridge
 * promised: confirm the details, then pay. It is NOT `checkout_recovery`,
 * which also arms the abandoned-checkout recovery funnel.
 */
export const REPORT_BRIDGE_CHECKOUT_PARAM = "open_checkout";

/**
 * Build the acquisition handoff without putting birth details in a server-loggable
 * query string. The hash is read by KundaliFormCard's direct-prefill path.
 */
export function buildReportInputHref({
  sourcePath,
  intent,
  planId,
  language = "en",
  birthContext = {},
}: {
  intent: SEOIntent;
  planId: SEOReportPlanId;
  sourcePath: string;
  language?: "en" | "hi";
  birthContext?: ReportInputBirthContext;
}): string {
  const params = new URLSearchParams({
    intent,
    source: sourcePath,
    next_report: planId,
    [REPORT_BRIDGE_CHECKOUT_PARAM]: "1",
  });
  appendBirthContext(params, birthContext);

  const formPath = language === "hi" ? "/hi/free-kundali/" : "/free-kundali/";
  return `${formPath}#${params.toString()}`;
}
